module.exports = __webpack_public_path__ + "img/img-error-page.png";